import React from 'react';
import { motion } from 'framer-motion';
import { Video, BarChart, Users, MessageSquare, Smartphone, Globe, Layers, Link } from 'lucide-react';
const features = [{
  icon: Video,
  label: 'Video & Live Interviews',
  pos: 'top-0 left-1/2 -translate-x-1/2 -translate-y-6'
}, {
  icon: BarChart,
  label: 'Employee Polls',
  pos: 'top-[15%] right-[10%]'
}, {
  icon: Users,
  label: 'Peer Sentiment',
  pos: 'bottom-[15%] right-[10%]'
}, {
  icon: MessageSquare,
  label: 'Leadership Messages',
  pos: 'bottom-0 left-1/2 -translate-x-1/2 translate-y-6'
}, {
  icon: Layers,
  label: 'Personalized Journeys',
  pos: 'bottom-[15%] left-[10%]'
}, {
  icon: Globe,
  label: 'Omnichannel Dist.',
  pos: 'top-[15%] left-[10%]'
}];
export const Slide04Snakker = () => {
  return <div className="relative w-full h-full flex flex-col justify-center px-24 bg-slate-950 overflow-hidden" data-id="element-75">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-900/50 to-slate-950" data-id="element-76" />

      <div className="relative z-10 w-full max-w-6xl mx-auto flex flex-col items-center" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-78">
          <h2 className="text-5xl font-bold tracking-tight mb-4 text-white" data-id="element-79">
            From live moments to{' '}
            <span className="text-red-500" data-id="element-80">active participation.</span>
          </h2>
          <p className="text-xl text-slate-400 font-light max-w-2xl mx-auto" data-id="element-81">
            Snakker transforms live content into personalized interactive
            experiences. It is much broader than just video.
          </p>
        </motion.div>

        <div className="relative w-[800px] h-[450px] flex items-center justify-center mt-8" data-id="element-82">
          {/* Central Node */}
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          duration: 0.8,
          type: 'spring'
        }} className="relative z-20 w-48 h-48 rounded-full bg-gradient-to-br from-red-600 to-red-900 flex items-center justify-center shadow-[0_0_60px_rgba(220,38,38,0.3)] border border-red-400/30" data-id="element-83">
            <div className="text-center" data-id="element-84">
              <span className="block text-2xl font-bold text-white tracking-wider" data-id="element-85">
                SNAKKER
              </span>
              <span className="block text-xs text-red-200 uppercase tracking-widest mt-1" data-id="element-86">
                Engine
              </span>
            </div>
          </motion.div>

          {/* Connecting Lines */}
          <svg className="absolute inset-0 w-full h-full z-0 opacity-20" viewBox="0 0 800 450" data-id="element-87">
            <circle cx="400" cy="225" r="180" fill="none" stroke="#ef4444" strokeWidth="1" strokeDasharray="4 4" className="animate-[spin_60s_linear_infinite]" data-id="element-88" />
            <circle cx="400" cy="225" r="280" fill="none" stroke="#ef4444" strokeWidth="1" strokeDasharray="4 4" className="animate-[spin_90s_linear_infinite_reverse]" data-id="element-89" />
          </svg>

          {/* Orbiting Features */}
          {features.map((feature, index) => <motion.div key={feature.label} initial={{
          opacity: 0,
          scale: 0
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.4 + index * 0.1,
          duration: 0.6,
          type: 'spring'
        }} className={`absolute ${feature.pos} z-10 flex flex-col items-center`} data-id="element-90">
              <div className="w-16 h-16 rounded-2xl bg-slate-900 border border-slate-700 flex items-center justify-center mb-3 shadow-xl backdrop-blur-md" data-id="element-91">
                <feature.icon className="w-7 h-7 text-slate-300" strokeWidth={1.5} data-id="element-92" />
              </div>
              <span className="text-sm font-medium text-slate-300 whitespace-nowrap bg-slate-950/80 px-3 py-1 rounded-full border border-slate-800" data-id="element-93">
                {feature.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </div>;
};